import { FileImageOutlined, HeartFilled, HeartOutlined } from "@ant-design/icons";
import { Button, Card, Space, Statistic } from "antd";
import { format, intervalToDuration, isBefore, isEqual } from "date-fns";
import { useEffect, useMemo, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ItemImage from '../../../assets/images/item_image.png';
import { ReactComponent as Medal } from '../../../assets/images/medal.svg';
import { useCareProductMutation, useUncareProductMutation } from "../../../redux/api/ProductApi";
import { AuctionResponse, BidderAcceptBidStatus, StartStatus } from "../../auction/types";
import { ItemCardStatus, preCostTypes, registerTypes } from "../types/types";
import RegisterAuction from '../../auction/online-auction/auction-list/components/RegisterAuction'
import PrepayModal from "./PrepayModal";
import { useAppDispatch, useAppSelector } from "../../../redux/Hooks";
import { toggleLoginModal } from "../../login/redux/LoginSlice";

type CardProps = {
    price?: number,
    description?: string,
    status: ItemCardStatus,
    item: AuctionResponse,
    reloadPage: () => void,
}

interface Countdown {
    day: number,
    hour: number,
    minute: number,
    second: number
}

const defaultCountdown: Countdown = {
    day: 0,
    hour: 0,
    minute: 0,
    second: 0,
}

const ItemCard = ({ price, description, status, item, reloadPage }: CardProps) => {
    const [countdown, setCountdown] = useState<Countdown>(defaultCountdown);
    const [isFavoriteHovering, setIsFavoriteHovering] = useState(false);
    const navigate = useNavigate()
    const timer: { current: NodeJS.Timeout | null } = useRef(null);
    // const [uncareVisible, setUncareVisible] = useState(false);

    const userState = useAppSelector(state => state.login);

    const [uncareProduct] = useUncareProductMutation();
    const [careProduct] = useCareProductMutation();
    const [registerVisible, setRegisterVisible] = useState(false);
    const [prepayVisible, setPrepayVisible] = useState(false);
    // const [isFavorite, setIsFavorite] = useState(false);

    const dispatch = useAppDispatch();

    useEffect(() => {
        let currentDate = new Date()
        let toDate = item.startAuctionDate

        if (item.startStatus === StartStatus.ONGOING) {
            toDate = item.endAuctionDate;
        }
        let endDate = toDate ? new Date(toDate) : currentDate;

        if (isBefore(endDate, currentDate) || isEqual(endDate, currentDate)) {
            setCountdown({
                day: 0,
                hour: 0,
                minute: 0,
                second: 0,
            })
        } else {
            timer.current = setInterval(() => {
                let difference = intervalToDuration({ start: new Date(), end: endDate });
                setCountdown({
                    day: difference.days || 0,
                    hour: difference.hours || 0,
                    minute: difference.minutes || 0,
                    second: difference.seconds || 0,
                })
            }, 1000)
        }

        return () => {
            if (timer.current) {
                clearInterval(timer.current);
            }
        };
    }, [item])

    const generateCardMeta = () => {
        let title = (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                <strong
                    style={{
                        padding: '0px 15px',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        width: '100%',
                        textAlign: 'center',
                        color: '#19191D'
                    }}
                >{item.productName}</strong>
                {/* Giá hiện tại check theo rule
                - Đấu giá lên thì hiển thị giá cao nhất
                - Đấu giá theo vòng hiển thị giá cao nhất vòng
                */}
                <span className="item-card-price-title">{status !== ItemCardStatus.INPROGRESS ? "Giá khởi điểm" : "Giá hiện tại"}</span>
                <div style={{ display: 'flex', alignItems: 'center', fontSize: 18, color: '#22C55E' }}>
                    <Statistic
                        value={status !== ItemCardStatus.INPROGRESS || !item.bidderAcceptBid?.valueOfBid ? item.startPrice : item.bidderAcceptBid?.valueOfBid}
                        groupSeparator="."
                        decimalSeparator=","
                        precision={0}
                        style={{ marginRight: 5 }}
                        valueStyle={{ fontFamily: 'Quicksand', color: '#22C55E', fontSize: 18 }} /> VNĐ
                </div>
            </div>
        )

        let description = (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>

                <span className="font-size-12" style={{ display: 'flex', justifyContent: 'center', marginBottom: 15, color: '#19191D' }}>
                    Thời gian đấu giá: <span style={{ marginLeft: 5 }}>{item.startAuctionDate ? format(new Date(item.startAuctionDate), "HH:mm dd/MM/yyyy") :
                        format(new Date(), "HH:mm dd/MM/yyyy")}</span>
                </span>
                {status === ItemCardStatus.NEW ?
                    <>
                        {(item.bidderResponseDTO?.registerStatus === -1 || !item.bidderResponseDTO) ?
                            <Button
                                style={{
                                    marginBottom: 20,
                                    visibility: item.seller.userId !== userState?.user?.userId && item.statute.endRegistrationDate
                                        && isBefore(new Date(), item.statute.endRegistrationDate) ? 'visible' : 'hidden'
                                }}
                                className="button-light-yellow font-size-16"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    toggleRegisterModal()
                                }}>
                                ĐĂNG KÝ
                            </Button> : <></>
                        }

                        {userState?.user?.userId && item.seller.userId !== userState?.user?.userId &&
                            (item?.bidderResponseDTO?.registerStatus === registerTypes.SUBMIT || item?.bidderResponseDTO?.registerStatus === registerTypes.SUCCESS) &&
                            (item.bidderResponseDTO?.preCostStatus === preCostTypes.NOTPAY || item.bidderResponseDTO?.preCostStatus === -1 || item.bidderResponseDTO?.preCostStatus === preCostTypes.FAILED) ?
                            <Button
                                style={{ marginBottom: 20, visibility: item.statute.endPrePaymentDate && isBefore(new Date(), item.statute.endPrePaymentDate) ? 'visible' : 'hidden' }}
                                className="button-light-yellow font-size-16"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    togglePrepayModal();
                                }}>
                                NỘP TIỀN
                            </Button> : <></>}

                        {(item.bidderResponseDTO?.registerStatus === 0 || item.bidderResponseDTO?.registerStatus === 1) && item.bidderResponseDTO?.preCostStatus === preCostTypes.WAITING ?
                            <div className="item-card-status item-card-status-yellow font-bold">
                                CHỜ ĐỐI SOÁT
                            </div> : <></>}

                        {item.bidderResponseDTO?.registerStatus === 1 && item.bidderResponseDTO?.preCostStatus === preCostTypes.DONE ?
                            <div className="item-card-status item-card-status-green font-bold">
                                ĐĂNG KÝ THÀNH CÔNG
                            </div> : <></>}

                        {item.bidderResponseDTO?.registerStatus === 2 ?
                            <div className="item-card-status item-card-status-red font-bold">
                                TỪ CHỐI THAM GIA
                            </div> : <></>}

                        {item.bidderResponseDTO?.registerStatus === 3 ?
                            <div className="item-card-status item-card-status-red font-bold">
                                ĐĂNG KÝ KHÔNG HỢP LỆ
                            </div> : <></>}
                    </>
                    : <></>}

                {status === ItemCardStatus.INPROGRESS ?
                    <div className="item-card-status item-card-status-blue font-bold">
                        ĐANG DIỄN RA
                    </div> : <></>}

                {status === ItemCardStatus.PAUSE ?
                    <div className="item-card-status item-card-status-gray font-bold">
                        ĐÃ TẠM DỪNG ĐẤU GIÁ
                    </div> : <></>}

                {status === ItemCardStatus.FAILED || (status === ItemCardStatus.SUCCESS &&
                    (!item.bidderAcceptBid?.valueOfBid || item.bidderAcceptBid?.status === BidderAcceptBidStatus.FAILED)) ?
                    <div className="item-card-status item-card-status-red-bold font-bold">
                        ĐẤU GIÁ KHÔNG THÀNH CÔNG
                    </div> : <></>}

                {status === ItemCardStatus.SUCCESS && item.bidderAcceptBid?.valueOfBid && item.bidderAcceptBid?.status === BidderAcceptBidStatus.SUCCESS ?
                    <div className="item-card-status item-card-status-green-bold font-bold" style={{ display: 'flex', flexDirection: 'column' }}>
                        <div style={{ fontSize: 12 }}>
                            Giá trúng đấu giá
                        </div>
                        <div style={{ fontSize: 16 }}>
                            <Statistic
                                value={item.bidderAcceptBid?.valueOfBid || 0}
                                groupSeparator="."
                                decimalSeparator=","
                                precision={0}
                                valueStyle={{ fontSize: 16, color: 'white' }}
                                suffix="VNĐ"
                            />
                        </div>
                    </div> : <></>}
            </div >
        )

        return (<Card.Meta title={title} description={description} />)
    }

    const onFavoriteMouseOver = () => {
        setIsFavoriteHovering(true);
    }

    const onFavoriteMouseOut = () => {
        setIsFavoriteHovering(false);
    }

    const onFavoriteClick = () => {
        if (!userState.user.userId) {
            dispatch(toggleLoginModal())
        } else if (item.isCare) {
            // uncare
            uncareProduct({ productId: item.productId, statuteId: item.statute.statuteId }).unwrap().then(() => {
                reloadPage();
            })
        } else if (!item.isCare) {
            // care
            careProduct({ productId: item.productId, statuteId: item.statute.statuteId }).unwrap().then(() => {
                reloadPage();
            })
        }
    }

    const toggleRegisterModal = () => {
        if (!userState.user.userId) {
            setRegisterVisible(false);
            dispatch(toggleLoginModal());
        } else if (!userState.incompleteProfile) {
            setRegisterVisible(!registerVisible)
        } else if (userState.incompleteProfile) {
            // Nếu chưa hoàn thành hồ sơ
            navigate("/profile/detail/redirect")
        }
    }

    const togglePrepayModal = () => {

        if (prepayVisible) {
            reloadPage();
        }
        setPrepayVisible(!prepayVisible);
    }

    const redirectOnCardClick = () => {
        navigate(`/auction-item/${item.productId}/${item.statute.statuteId}`)
    }

    const cardImageElement = useMemo(() => {
        let cardUrl = process.env.REACT_APP_API_URL + `/files/downloadFile/`;

        if (item.vbAttachmentImages && item.vbAttachmentImages?.length) {
            let avatarIndex = item.vbAttachmentImages.findIndex(img => img.storageType === "avatar");
            cardUrl += avatarIndex !== -1 ? `${item.vbAttachmentImages[avatarIndex].attachmentId}` : `${item.vbAttachmentImages[0].attachmentId}`;
        } else {
            cardUrl = "";
        }

        if (cardUrl) {
            return (
                <img
                    style={{ objectFit: 'cover', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', borderRadius: '15px 15px 0px 0px' }}
                    width='100%'
                    height='250px'
                    alt="example"
                    src={cardUrl}
                    className="item-card-cover" />
            )
        }

        return (
            <div style={{ width: '100%', height: 250, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <FileImageOutlined style={{ fontSize: 50 }} />
            </div>
        )
    }, [item.vbAttachmentImages])

    const generateCardCover = () => {
        return (
            <div
                className="item-card-cover"
            >
                <div className="item-card-action">
                    {item.startStatus !== StartStatus.FINISH ?
                        <Space size={5}>
                            <div className="item-card-time">{countdown.day}</div>
                            <div className="item-card-time">{countdown.hour}</div>
                            <div className="item-card-time">{countdown.minute}</div>
                            <div className="item-card-time">{countdown.second}</div>
                        </Space> : <div></div>}
                    <div
                        style={{ alignSelf: 'center' }}
                        onMouseEnter={onFavoriteMouseOver}
                        onMouseLeave={onFavoriteMouseOut}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onFavoriteClick();
                        }}>
                        {isFavoriteHovering || item.isCare ?
                            <HeartFilled style={{ color: '#E59F17', fontSize: 25 }} /> :
                            <HeartOutlined style={{ color: 'white', fontSize: 25 }} />
                        }

                    </div>
                </div>

                {cardImageElement}
            </div>
        )
    }

    return (
        <Link to={`/auction-item/${item.productId}/${item.statute.statuteId}`} reloadDocument style={{ width: '100%', maxWidth: 280 }}>
            <Card
                className="custom-grid-card"
                hoverable
                style={{ borderRadius: '15px', maxWidth: 280, width: '100%' }}
                cover={generateCardCover()}
            // onClick={redirectOnCardClick}
            >
                {generateCardMeta()}
            </Card>

            {registerVisible ? <RegisterAuction
                visible={registerVisible}
                itemId={item.productId}
                statuteId={item.statute.statuteId}
                toggleModal={toggleRegisterModal}
                onSuccess={reloadPage}
            /> : <></>}

            {prepayVisible ? <PrepayModal
                visible={prepayVisible}
                productId={item.productId}
                productName={item.productName}
                statuteId={item.statute.statuteId}
                preCost={item.preCost + (item.anotherCost || 0)}
                toggleModal={togglePrepayModal}
                onSuccess={reloadPage}
            /> : <></>}
        </Link>
    )
}

export default ItemCard;